/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseComponent from "./BaseCom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "./FormInput";
import FormLabel from "./FormLabel";
import Card from "./Card";
import L from './Lang';

export default class Insurance extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            edit: props.edit
        };
        this.remove = props.remove ? props.remove : false;
        this.insuranceTypes = [
            { id: 'Primary', name: 'Primary' },
            { id: 'Secondary', name: 'Secondary' },
            { id: 'Tertiary', name: 'Tertiary' },
            { id: 'Employer', name: 'Employer' },
            { id: 'Dependant', name: 'Dependant' }
        ];
        this.insuranceClasses = [
            { id: 'Medicare', name: 'Traditional Medicare' },
            { id: 'Medicaid', name: 'Medicaid' },
            { id: 'Medicare Replacement Plan', name: 'Medicare Replacement Plan' },
            { id: 'HMO', name: 'HMO' },
            { id: 'PPO', name: 'PPO' },
            { id: 'Supplemental', name: 'Supplemental' },
            { id: 'Unknown', name: 'Unknown' }
        ];
        this.onChange = props.onChange;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.edit !== this.props.edit)
            this.setState({ edit: this.props.edit });
        if (prevProps.item !== this.props.item)
            this.setState({ item: this.props.item });
    }

    render() {

        if (!this.props.edit) {
            return <Card title="Insurance">
                <div className="row">
                    <div className="col">
                        <FormLabel model={this.state.item.carrierName} label="Insurance Provider" name="carrierName" type="text" required={!this.props.optional} onChange={this.onChange} />
                    </div>
                    <div className="col">
                        <FormLabel model={this.state.item.memberID} label="Member ID" name="memberID" type="text" required={!this.props.optional} onChange={this.onChange} />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <FormLabel model={this.state.item.groupNumber} label="Group Number" name="groupNumber" type="text" required={false} onChange={this.onChange} />
                    </div>
                    <div className="col">
                        <FormLabel model={this.state.item.insuranceType} label="Insurance Type" name="insuranceType" type="select" options={this.insuranceTypes} required={false} onChange={this.onChange} />
                    </div>
                </div>
            </Card>;
        }

        return (<Card title="Insurance" headerButtons={this.props.remove && !this.state.item.auto && <button type="button" onClick={(e) => this.props.remove(this.state.item)} className="btn btn-danger fs-6"><FontAwesomeIcon icon={fa.faTrash} /></button>}>
            <div className="row">
                <div className="col">
                    <FormInput disabled={this.props.disabled || this.state.item.auto} model={this.state.item} label="Insurance Provider" name="carrierName" type="text" required={!this.props.optional} onChange={this.onChange} />
                </div>
                <div className="col">
                    <FormInput disabled={this.props.disabled || this.state.item.auto} model={this.state.item} label="Member ID" name="memberID" type="text" required={!this.props.optional} onChange={this.onChange} />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <FormInput disabled={this.props.disabled || this.state.item.auto} model={this.state.item} label="Group Number" name="groupNumber" type="text" required={false} onChange={this.onChange} />
                </div>
                <div className="col">
                    <FormInput disabled={this.props.disabled} model={this.state.item} label="Insurance Type" name="insuranceType" type="select" options={this.insuranceTypes} required={false} onChange={this.onChange} />
                </div>
                <div className="col">
                    <FormInput disabled={this.props.disabled || this.state.item.auto} model={this.state.item} label="Insurance Class" name="insuranceClass" type="select" options={this.insuranceClasses} required={false} onChange={this.onChange} />
                </div>
            </div>
            {this.state.item.auto ? <p className="text-info"><L>This record was added from the information above. To make any changes, please make them above.</L></p> : null}
        </Card>)
    }
}